import React from 'react'
import classNames from 'classnames'
import { Button } from '../../../../../components/Button/Button'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'
import { type User } from '../../../../../models/User'
import { type ManualParticipant } from '../../../../../models/ManualParticipant'
import { getManualParticipantDisplayReason } from './utils'

interface ManualParticipantIndicatorProps {
  user: User
  manualParticipant: ManualParticipant
  manualParticipantAddedByNames: Record<string, string>
  onEditClicked: (user: User, manualParticipant: ManualParticipant) => void
}

export const ManualParticipantIndicator: React.FC<ManualParticipantIndicatorProps> = ({
  user,
  manualParticipant,
  manualParticipantAddedByNames,
  onEditClicked,
}) => {
  const addedByName = manualParticipantAddedByNames[manualParticipant.addedByUserId] ?? manualParticipant.addedByUserId
  const unconfirmedReason = !manualParticipant.addedReasonConfirmed

  return (
    <Tooltip
      className='manual-participant-tooltip'
      placement='top'
      offset={[0, 10]}
      tooltipContent={
        <div className='d-flex flex-column gap-2'>
          <div className='paragraph-small text-start text-white'>
            <span>Added by </span>
            <span className='bold'>{addedByName}</span>
          </div>
          <div className='manual-participant-tooltip-reason'>
            <span
              className={classNames('paragraph-small fst-italic', {
                'manual-participant-tooltip-reason-unconfirmed': unconfirmedReason,
                'text-white': !unconfirmedReason,
              })}
            >
              {`Reason: ${getManualParticipantDisplayReason(manualParticipant)}`}
            </span>
          </div>
        </div>
      }
    >
      <Button variant='header' className='p-1 ps-2 pe-2 manual-participant-indicator-button' onClick={() => onEditClicked(user, manualParticipant)}>
        <span className='position-relative d-inline-flex gap-1 justify-content-center align-items-center'>
          <i className='bi bi-person-plus'></i>
          {unconfirmedReason ? <span className='manual-participant-indicator-dot' /> : null}
        </span>
      </Button>
    </Tooltip>
  )
}
